import type { TFunction } from "i18next";
import useTranslation from "@hooks/use_translation";
import { differenceInCalendarDays } from "date-fns";

const timeSinceText = (timestamp: string, t: TFunction, activityKey: string): string => {
  const date = Date.parse(timestamp);

  if (isNaN(date)) {
    return "";
  }

  const daysSince = differenceInCalendarDays(new Date(), date);
  if (daysSince < 7) {
    return t(activityKey + "DaysAgo", { count: daysSince });
  }

  const weeksSince = Math.floor(daysSince / 7);
  return t(activityKey + "WeeksAgo", { count: weeksSince });
};

const useTimeSinceDateText = (timestamp: string, activityKey: string): string => {
  const { t } = useTranslation("jobSearch");
  return timeSinceText(timestamp, t, activityKey);
};

export default useTimeSinceDateText;
